import { createAsyncThunk } from '@reduxjs/toolkit';
import { checkHasEnoughMinutes } from '@/shared/utils-tmp/user/checkHasEnoughMinutes';
import { RootState } from '../../index';
import { setIsNeedToPay } from '../BillingSlice';

export const checkIsUserNeedToPay = createAsyncThunk<
  void,
  undefined,
  {
    state: RootState;
  }
>('billing/checkIsUserNeedToPay', (_, { dispatch, getState }) => {
  const {
    user,
    project: { project },
  } = getState();
  if (user && project) {
    const hasEnoughMinutes = checkHasEnoughMinutes(user, project);
    dispatch(setIsNeedToPay(hasEnoughMinutes));
  }
});
